export const GET_ALL_BLOGS = 'GET_ALL_BLOGS';
export const GET_BOOKMARKED_BLOGS = 'GET_BOOKMARKED_BLOGS';
export const GET_MY_APPROVED_BLOGS = 'GET_MY_APPROVED_BLOGS';
export const GET_MY_DRAFT_BLOGS = 'GET_MY_DRAFT_BLOGS';
export const GET_MY_PENDING_BLOGS = 'GET_MY_PENDING_BLOGS';
export const GET_MY_REJECTED_BLOGS = 'GET_MY_REJECTED_BLOGS';
export const GET_POPULAR_BLOGS = 'GET_POPULAR_BLOGS';
export const GET_BLOG_TAGS = "GET_BLOG_TAGS"
export const SET_ALL_BLOGS = "SET_ALL_BLOGS"
export const SET_MY_BLOGS = "SET_MY_BLOGS"
export const SET_BOOKMARKED_BLOGS = 'SET_BOOKMARKED_BLOGS';
export const SET_POPULAR_BLOGS = 'SET_POPULAR_BLOGS';
export const SET_BLOG_TAGS = 'SET_BLOG_TAGS'

export default {
    namespaced: true,
    state: {
        allBlogs: [],
        bookmarkedBlogs: [],
        myBlogs: {
            approved: [],
            drafts: [],
            pending: [],
            rejected: []
        },
        popularBlogs: [],
        tags: [],
    },
    getters: {
        [GET_ALL_BLOGS](state) {
            return state.allBlogs
        },
        [GET_MY_APPROVED_BLOGS](state) {
            return state.myBlogs.approved
        },
        [GET_BOOKMARKED_BLOGS](state) {
            return state.bookmarkedBlogs
        },
        [GET_MY_DRAFT_BLOGS](state) {
            return state.myBlogs.drafts
        },
        [GET_MY_PENDING_BLOGS](state) {
            return state.myBlogs.pending
        },
        [GET_MY_REJECTED_BLOGS](state) {
            return state.myBlogs.rejected
        },
        [GET_POPULAR_BLOGS](state) {
            return state.popularBlogs
        },
        [GET_BLOG_TAGS](state) {
            return state.tags
        },
    },
    mutations: {
        [SET_ALL_BLOGS](state, payload) {
            state.allBlogs = [...new Map(payload.map(blog => [blog.slug, blog])).values()]
        },
        [SET_MY_BLOGS](state, {tabIndex, blogs}) {
            switch (tabIndex) {
                case 0:
                    state.myBlogs.approved = [...new Map(blogs?.map(blog => [blog.slug, blog])).values()]
                    break;
                case 1:
                    state.myBlogs.pending = [...new Map(blogs.map(blog => [blog.slug, blog])).values()]
                    break;
                case 2:
                    state.myBlogs.drafts = [...new Map(blogs.map(blog => [blog.slug, blog])).values()]
                    break;
                case 3:
                    state.myBlogs.rejected = [...new Map(blogs.map(blog => [blog.slug, blog])).values()]
                    break;
            }
        },
        [SET_POPULAR_BLOGS](state, payload) {
            state.popularBlogs = [...new Map(payload.map(blog => [blog.slug, blog])).values()]
        },
        [SET_BOOKMARKED_BLOGS](state, payload) {
            state.bookmarkedBlogs = [...new Map(payload.map(blog => [blog.slug, blog])).values()]
        },
        [SET_BLOG_TAGS](state, payload) {
            state.tags = [...new Map(payload.map(tag => [tag.id, tag])).values()]
        },
    }
}
